import angular from 'angular';

class ModalReInviteRejectedSubEntityCtrl {
    /*@ngInject*/
    constructor(invitedEntitySvc, logger) {
        this.invitedEntitySvc = invitedEntitySvc;
        this.logger = logger;
    }

    reInviteRejectedSubEntities() {
        let vm = this;

        this.invitedEntitySvc.reInviteRejectedSubEntities(vm.resolve.rejectedCodes, vm.resolve.invitedEntityId).then(
            data => {
                this.logger.success('Réinvitation effectuée avec succès', data);
                vm.modalInstance.close();
            },
            error => {
                this.logger.error('Echec réinvitation', error);
                vm.modalInstance.close();
            })

    }

    cancel() {
        this.modalInstance.close();
    }
}

angular.module('app.principal').component('modalReInviteRejectedSubEntityCtrl', {
    templateUrl: require('./modal-reinvite-rejected-subentity.html'),
    controller: ModalReInviteRejectedSubEntityCtrl,
    bindings: {
        resolve: '<',
        modalInstance: '<',
    },
});
